module.exports = __webpack_public_path__ + "img/workspace-onboarding/install-chrome-extension-60d54b67a0a4f6d6f150664effb0a5c1.png";